<div>
  <h6 class="content-header">True likes and comments</h6>
  <div class="card" [ngClass]="(isAdmin() | async) ? 'm-portlet--tabs' : ''">
    <app-progress type="like"></app-progress>
    <div class="card-tabs" *ngIf="(isAdmin() | async)">
        <ul class="tabs" role="tablist">
          <li class="tabs-item" [ngClass]="adminCharts === false ? 'active' : ''">
            <a (click)="adminChartsToggle()">
              Charts
            </a>
          </li>
          <li class="tabs-item"  disabled="1" [ngClass]="adminCharts === true ? 'active' : ''">
            <a (click)="adminChartsToggle()">
              Admin charts
            </a>
          </li>
        </ul>
    </div>
    <div class="spinner" *ngIf="!(profileState | async).loader['audit']['mediaStat']"></div>
    <div class="" [ngClass]="!(profileState | async).loader['audit']['mediaStat'] ? 'background-loader' : ''">
      <div class="row m-0">
        <div class="col-md-6 card-body border-right no-border-sm" [ngClass]="!((profileState | async).boxExampleStatus[sectionName.like]) && !((profileState | async).audit !== null && (profileState | async).audit.status) ? 'sample-chart' : ''">
          <app-audit-example [name]="sectionName.like">
            <app-audit-no-mention type="chart" name="Likes">
              <div class="chart-title flex flex-wrap">
                <img class="icon-title" src="./assets/images/icons/likes.png"/>
                <div>
                  <h3 class="card-header">
                    Likes
                    <a data-tooltip="Likes authenticity - average number of likes per post added by authentic followers.
                True likes - added by aunthentic followers.
                Suspicious likes - likes added by accounts recognized as fake, bot or POD groups.">
                      <img class="icon-info" src="./assets/images/icons/info.png" />
                    </a>
                  </h3>
                  <p class="summary">
                    <a *ngIf="!(profileState | async).boxExampleStatus[sectionName.like] && (profileState | async).audit.status == 0">
                      <app-price-popup [type]="2"></app-price-popup>
                    </a>
                    <b *ngIf="(profileState | async).boxExampleStatus[sectionName.like] || ((profileState | async).mediaStat !== null && (profileState | async).audit.status > 0)">
                      {{(profileState | async).mediaStat.like.true_media_avg.value | separateNumbers}}
                    </b>
                    <span class="sub-text">True avg likes per post</span>
                    <a data-tooltip="Average number of likes per post added by authentic followers">
                      <img class="icon-info ml-1" src="./assets/images/icons/info.png" />
                    </a>
                  </p>
                </div>
              </div>

              <div class="chart" *ngIf="chartsMedia !== undefined && !adminCharts">
                <app-audit-placeholder [type]="auditType()" [name]="sectionName.like"></app-audit-placeholder>
                <div class="row">
                  <div class="col-sm-6">
                    <div [chart]="chartsMedia[2]"></div>
                  </div>
                  <div class="col-sm-6 mt-md-6">
                    <app-pie-legend [data]="chartsMedia[2]"></app-pie-legend>
                  </div>
                </div>
              </div>

              <div class="chart" *ngIf="chartsMedia !== undefined && adminCharts && (isAdmin() | async)">

                <div class="row">
                  <div class="col-sm-6">
                    <div [chart]="chartsMedia[0]"></div>
                  </div>
                  <div class="col-sm-6 mt-md-5">
                    <app-pie-legend [data]="chartsMedia[0]"></app-pie-legend>
                  </div>
                </div>
              </div>
              <div class="chart-summary border-sm-bottom pb-sm-4" *ngIf="(profileState | async).mediaStat !== null && (profileState | async).audit !== null && ((profileState | async).audit.status == 2 || (profileState | async).audit.status == 0)">
              <span class="badge" [ngStyle]="{'background-color': getLevel((profileState | async).mediaStat.like.media_distribution.true_media.percent).bgcolor}" *ngIf="(profileState | async).boxExampleStatus[sectionName.like] || (profileState | async).audit.status == 2">
                <span class="dot" [ngStyle]="{'background-color': getLevel((profileState | async).mediaStat.like.media_distribution.true_media.percent).dotcolor}"></span>
                {{getLevel((profileState | async).mediaStat.like.media_distribution.true_media.percent).text}}
              </span>
                <a *ngIf="!(profileState | async).boxExampleStatus[sectionName.like] && (profileState | async).audit.status == 0">
                  <app-price-popup [type]="2"></app-price-popup>
                </a>
                <img class="arrow" src="./assets/images/icons/arrow.png" />
                <span class="chart-description">
                <span class="sub-text">
                  Likes spread
                </span>
                <a data-tooltip="Likes rating">
                  <img class="icon-info" src="./assets/images/icons/info.png" />
                </a>
              </span>
                <p class="mt-3">
                  <b *ngIf="(profileState | async).boxExampleStatus[sectionName.like] || (profileState | async).audit.status == 2">{{(profileState | async).mediaStat.like.media_distribution.true_media.percent | number:'1.2'}}%</b>
                  <a *ngIf="!(profileState | async).boxExampleStatus[sectionName.like] && (profileState | async).audit.status == 0" class="trial-icon mr-1">
                    <app-price-popup [type]="2"></app-price-popup>
                  </a>
                  <span class="text-medium">
                  likes looks authentic
                </span>
                </p>
              </div>
            </app-audit-no-mention>
          </app-audit-example>
        </div>
        <div class="col-md-6 card-body" [ngClass]="!(profileState | async).boxExampleStatus[sectionName.comment] && !((profileState | async).audit !== null && (profileState | async).audit.status) ? 'sample-chart' : ''">
          <app-audit-example [name]="sectionName.comment">
            <app-audit-no-mention type="chart" name="Comments">
              <div class="chart-title flex flex-wrap">
                <img class="icon-title" src="./assets/images/icons/comments.png"/>
                <div>
                  <h3 class="card-header">
                    Comments
                    <a data-tooltip="Comments authenticity - average number of comments per post added by authentic followers.
                    True comments - number of comments aded by authentic followers.
                    Suspicious comments - comments added by accounts recognized as fake, bot or POD groups.">
                      <img class="icon-info" src="./assets/images/icons/info.png" />
                    </a>
                  </h3>
                  <p class="summary">
                    <a *ngIf="!(profileState | async).boxExampleStatus[sectionName.comment] && (profileState | async).audit.status == 0">
                      <app-price-popup [type]="2"></app-price-popup>
                    </a>
                    <b *ngIf="(profileState | async).boxExampleStatus[sectionName.comment] || (profileState | async).mediaStat !== null && (profileState | async).audit.status > 0">
                      {{(profileState | async).mediaStat.comment.true_media_avg.value | separateNumbers}}
                    </b>
                    <span class="sub-text">True avg comments per post</span>
                    <a data-tooltip="Average number of comments per post added by authentic followers">
                      <img class="icon-info ml-1" src="./assets/images/icons/info.png" />
                    </a>
                  </p>
                </div>
              </div>

              <div class="chart" *ngIf="chartsMedia !== undefined && !adminCharts">
                <app-audit-placeholder [type]="auditType()" [name]="sectionName.comment"></app-audit-placeholder>
                <div class="row">
                  <div class="col-sm-6">
                    <div [chart]="chartsMedia[3]"></div>
                  </div>
                  <div class="col-sm-6 mt-md-6">
                    <app-pie-legend [data]="chartsMedia[3]"></app-pie-legend>
                  </div>
                </div>
              </div>
              <div class="chart" *ngIf="chartsMedia !== undefined && adminCharts && (isAdmin() | async)">
                <div class="row">
                  <div class="col-sm-6">
                    <div [chart]="chartsMedia[1]"></div>
                  </div>
                  <div class="col-sm-6 mt-md-5">
                    <app-pie-legend [data]="chartsMedia[1]"></app-pie-legend>
                  </div>
                </div>
              </div>

              <div class="chart-summary" *ngIf="(profileState | async).mediaStat !== null && (profileState | async).audit !== null && ((profileState | async).audit.status == 2 || (profileState | async).audit.status == 0)">
              <span class="badge" [ngStyle]="{'background-color': getLevel((profileState | async).mediaStat.comment.media_distribution.true_media.percent).bgcolor}" *ngIf="(profileState | async).boxExampleStatus[sectionName.comment] || (profileState | async).audit.status == 2">
                <span class="dot" [ngStyle]="{'background-color': getLevel((profileState | async).mediaStat.comment.media_distribution.true_media.percent).dotcolor}"></span>
                {{getLevel((profileState | async).mediaStat.comment.media_distribution.true_media.percent).text}}
              </span>
                <a *ngIf="!(profileState | async).boxExampleStatus[sectionName.comment] && (profileState | async).audit.status == 0">
                  <app-price-popup [type]="2"></app-price-popup>
                </a>
                <img class="arrow" src="./assets/images/icons/arrow.png" />
                <span class="chart-description">
                <span class="sub-text">
                  Comments authenticity
                </span>
                <a data-tooltip="Comments rating">
                  <img class="icon-info" src="./assets/images/icons/info.png" />
                </a>
              </span>

                <p class="mt-3">
                  <b *ngIf="(profileState | async).boxExampleStatus[sectionName.comment] || (profileState | async).audit.status == 2">{{(profileState | async).mediaStat.comment.media_distribution.true_media.percent | number:'1.2'}}%</b>
                  <a *ngIf="!(profileState | async).boxExampleStatus[sectionName.comment] && (profileState | async).audit.status == 0">
                    <app-price-popup [type]="2"></app-price-popup>
                  </a>
                  <span class="text-medium">
                  comments looks authentic
                </span>
                </p>
              </div>
            </app-audit-no-mention>
          </app-audit-example>
        </div>
      </div>
    </div>
  </div>
</div>
